/** Persist as a single `phone` field: optional ITU-T style ext (e.g. +976) + local number. */
export function splitStoredPhone(phone: string | undefined): { ext: string; number: string } {
  const p = (phone ?? '').trim();
  if (!p) return { ext: '', number: '' };
  const m = p.match(/^(\+\d{1,4})\s*(.*)$/);
  if (m) return { ext: m[1], number: (m[2] ?? '').trim() };
  return { ext: '', number: p };
}

export function joinStoredPhone(ext: string, number: string): string {
  const e = ext.trim();
  const n = number.trim();
  if (e && n) return `${e} ${n}`;
  return e || n;
}
